import React from "react";

export class Raspolozivo extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return <table className="margin-bottom-small text-medium lineheight-medium">
            <tbody>
                <tr>
                    <td className="text-bold">RASPOLOŽIVO</td>
                    <td className="text-right text-bold">{this.props.user && casino.utils.numberWithCurrencyFromated(this.props.user.ukupnoRaspolozivo, this.props.user.valuta)}</td>
                </tr>
                <tr>
                    <td>Glavni</td>
                    <td className="text-right">{this.props.user && casino.utils.numberWithCurrencyFromated(this.props.user.sportRaspolozivo, this.props.user.valuta)}</td>
                </tr>
                <tr>
                    <td>Casino</td>
                    <td className="text-right">{this.props.user && casino.utils.numberWithCurrencyFromated(this.props.user.casinoRaspolozivo, this.props.user.valuta)}</td>
                </tr>
                {this.props.user && !!this.props.user.casinoPrewagerBonusIznos && <tr>
                    <td>Casino bonus</td>
                    <td className="text-right">{this.props.user && casino.utils.numberWithCurrencyFromated(this.props.user.casinoPrewagerBonusIznos, this.props.user.valuta)}</td>
                </tr>}
            </tbody>
        </table>
    }
};
